import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchLatestBlogPosts } from "@/lib/blogApi";

export default function LatestPosts() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        fetchLatestBlogPosts(3)
            .then((rows) => {
                if (alive) setPosts(rows || []);
            })
            .catch(() => {})
            .finally(() => {
                if (alive) setLoading(false);
            });
        return () => {
            alive = false;
        };
    }, []);

    if (!loading && posts.length === 0) return null;

    return (
        <section
            className="bg-mm-bg/40 py-16 sm:py-20"
            aria-labelledby="latest-posts-heading"
            data-testid="home-latest-posts"
        >
            <div className="mm-container">
                <div className="mb-10 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                        <div className="mm-eyebrow">From the blog</div>
                        <h2
                            id="latest-posts-heading"
                            className="mt-2 font-serif text-3xl text-mm-navy sm:text-4xl"
                        >
                            Plain-English guides
                        </h2>
                        <p className="mt-2 max-w-xl text-sm text-mm-muted">
                            Written for real families — not insurance insiders.
                        </p>
                    </div>
                    <Link
                        to="/blog"
                        className="inline-flex items-center gap-1 text-sm font-medium text-mm-blue hover:underline"
                        data-testid="home-latest-posts-cta"
                    >
                        Browse the blog <ArrowRight size={14} />
                    </Link>
                </div>
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {posts.map((p) => (
                        <a
                            key={p.slug}
                            href={`/blog/${p.slug}`}
                            className="group overflow-hidden rounded-2xl border border-mm-line bg-white transition-shadow hover:shadow-card"
                            data-testid={`home-latest-card-${p.slug}`}
                        >
                            <div className="aspect-video overflow-hidden bg-mm-bg">
                                {p.hero_image_url && (
                                    <img
                                        src={p.hero_image_url}
                                        alt={p.hero_image_alt || p.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                )}
                            </div>
                            <div className="p-5">
                                <div className="text-[0.72rem] uppercase tracking-wider text-mm-blue">
                                    {p.category}
                                </div>
                                <h3 className="mt-2 font-serif text-lg text-mm-navy group-hover:text-mm-blue">
                                    {p.title}
                                </h3>
                                <p className="mt-2 line-clamp-3 text-sm text-mm-muted">
                                    {p.excerpt}
                                </p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
